import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { EditdatagridComponent } from '@app/shared/custom-component/editdatagrid/editdatagrid.component';
import { DateMaskDirective } from '@app/shared/directives/dateMask.directive';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { DxDataGridModule, DxPopupModule, DxTemplateModule, DxButtonModule } from 'devextreme-angular';
import { ChipModule } from 'primeng/chip';
import { SystemConfigurationService } from '../system-configuration.service';
import { AlertService } from '@app/@core/services/alert.service';
import { LocalService } from '@app/@core/services/local.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { HttpService } from '@app/@core/services/http.service';
import { patternMatch } from '@app/shared/constants/validators.model';
import { DATE_FIELDS } from '@app/shared/constants/queue.constants';
import { errorMessages, ModalConfig } from '@app/shared/constants/modal.model';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-data-template',
  templateUrl: './data-template.component.html',
  styleUrls: ['./data-template.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DxDataGridModule,
    DxPopupModule,
    DxTemplateModule,
    DxButtonModule,
    MatTooltipModule,
    ReactiveFormsModule,
    FormsModule,
    PrimengModule,
    ChipModule,
    DataGridComponent
  ]
})




export class DataTemplateComponent {

  portaltype: any;
  portalTypesData: any = [];
  columns: any = [];
  userSessionData: any;
  actionColumnWidth: number = 120;
  templateLeaHistoryData: any = [];
  templateEppHistoryData: any = [];
  isShowEdit: boolean = true;
  isShowDelete: boolean = true;
  isVisible = true;
  isActionVisible = true;
  showLeacreatetemplate = false;
  showEppcreatetemplate = false;
  template_name: any = '';
  templateLeagridConfig = [
    {
      columnDef: 'template_name',
      header: 'Template Name',
      filter: true,
      width: 260
    },
    {
      columnDef: 'base_template',
      header: 'Base Template',
      filter: true,
      width: 260
    },
    {
      columnDef: 'updated_date',
      header: 'Uploaded Date',
      filter: true,
      dateFormat: 'date',
      width: 140
    },
    {
      columnDef: 'updated_by',
      header: 'Uploaded By',
      filter: true,
      width: 260
    },
    {
      columnDef: 'template_status',
      header: 'Status',
      filter: true,
      width: 260,
      badge: true
    }
  ];
  templateEppgridConfig = [
    {
      columnDef: 'template_name',
      header: 'Template Name',
      filter: true,
      width: 260,

    },
    {
      columnDef: 'base_template',
      header: 'Base Template',
      filter: true,
      width: 260
    },
    {
      columnDef: 'updated_date',
      header: 'Uploaded Date',
      filter: true,
      dateFormat: 'date',
      width: 140
    },
    {
      columnDef: 'updated_by',
      header: 'Uploaded By',
      filter: true,
      width: 260
    },
    {
      columnDef: 'template_status',
      header: 'Status',
      filter: true,
      width: 260,
      badge: true
    }
  ];
  availableFieldsLea: any = [];
  availableFieldsEpp: any = [];
  selectedFieldsLea: any = [];
  selectedFieldsEpp: any = [];
  selectedTemplate: any;
  editbtn: boolean = false;
  lookupToast: any = [];
  lookupErrorMessages: any = [];
  modalref: NgbModalRef;
  private eppRefDocUploadModalRef: NgbModalRef | null = null;
  editColSelId: any;
  editTempId: any;
  currentPageSize: any = 10;
  displayMode: string = 'compact';
  btnclicked: boolean = false;
  @Input() set pageSize(value: number) {
    if (value) {
      this.currentPageSize = value;
    } else {
      this.currentPageSize = 20;
    }
  }
  template_name_epp: string = '';
  selectedTemplateEpp: any;
  templateLeaDropdownData: any = [];
  templateEppDropdownData: any = [];

  // EPP Reference Documents
  eppRefDocsList: any[] = [];
  eppRefDocsGridConfig = [
    { columnDef: 'file_name', header: 'Document Name', filter: true, width: 260, disabled: true },
    { columnDef: 'created_date', header: 'Uploaded Date', filter: true, dateFormat: 'date', width: 140 },
    { columnDef: 'created_by', header: 'Uploaded By', filter: true, width: 260 },
    { columnDef: 'template_status', header: 'Status', filter: true, width: 140, badge: true }
  ];
  eppRefDocsVisibleColumns: { [key: string]: boolean } = {
    file_name: true, created_date: true, created_by: true, template_status: true
  };
  showEppRefDocColumnChooser = false;
  eppRefDocUploadData: any = { file: null, fileName: '', type: '' };
  eppRefDocUploadError: string | null = null;
  eppRefDocOneFileIsRequired = false;
  eppRefDocSaveEnable = false;
  eppRefDocShowText = false;
  eppRefDocShowErrorBanner = false;
  eppRefDocErrorBannerMessage = '';
  selectedEppRefDocRow: any = null;
  selectedRefDocCategory: 'EPP' | 'LEA' = 'EPP';
  @ViewChild('eppRefDocFileInputRef') eppRefDocFileInputRef!: ElementRef<HTMLInputElement>;

  // LEA Reference Documents
  leaRefDocsList: any[] = [];
  leaRefDocsGridConfig = [
    { columnDef: 'file_name', header: 'Document Name', filter: true, width: 260, disabled: true },
    { columnDef: 'created_date', header: 'Uploaded Date', filter: true, dateFormat: 'date', width: 140 },
    { columnDef: 'created_by', header: 'Uploaded By', filter: true, width: 260 },
    { columnDef: 'template_status', header: 'Status', filter: true, width: 140, badge: true }
  ];
  leaRefDocsVisibleColumns: { [key: string]: boolean } = {
    file_name: true, created_date: true, created_by: true, template_status: true
  };
  showLeaRefDocColumnChooser = false;
  eppRefDocDataGridConfig: DataGridVO = DataGridVO.create({
    customHeaders: [
      { dataField: 'file_name', caption: 'Document Name', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },
      { dataField: 'created_date', caption: 'Uploaded Date', allowFiltering: true, dataType: 'date', allowSearch: { isSearchEnable: true, type: 'date' } },
      { dataField: 'created_by', caption: 'Uploaded By', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },
      { dataField: 'template_status', caption: 'Status', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } }
    ],
    visibleColumns: { file_name: true, created_date: true, created_by: true, template_status: true },
    showActionsColumn: true,
    data: [],
    role: '',
    activeTab: ''
  });
  leaRefDocDataGridConfig: DataGridVO = DataGridVO.create({
    customHeaders: [
      { dataField: 'file_name', caption: 'Document Name', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },
      { dataField: 'created_date', caption: 'Uploaded Date', allowFiltering: true, dataType: 'date', allowSearch: { isSearchEnable: true, type: 'date' } },
      { dataField: 'created_by', caption: 'Uploaded By', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },
      { dataField: 'template_status', caption: 'Status', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } }
    ],
    visibleColumns: { file_name: true, created_date: true, created_by: true, template_status: true },
    showActionsColumn: true,
    data: [],
    role: '',
    activeTab: ''
  });
  leaRefDocUploadData: any = { file: null, fileName: '', type: '' };
  leaRefDocUploadError: string | null = null;
  leaRefDocOneFileIsRequired = false;
  leaRefDocSaveEnable = false;
  leaRefDocShowText = false;
  leaRefDocShowErrorBanner = false;
  leaRefDocErrorBannerMessage = '';
  private leaRefDocUploadModalRef: NgbModalRef | null = null;
  @ViewChild('leaRefDocFileInputRef') leaRefDocFileInputRef!: ElementRef<HTMLInputElement>;
  deleteId : number ;

  constructor(private systemConfigurationService: SystemConfigurationService, private readonly alertService: AlertService,
    private sessionStorage: LocalService, private httpService: HttpService, private readonly modalService: NgbModal
  ) {
  }

  ngOnInit() {
    this.getTemplateTypes();
    this.getToastMessages();
    this.getErrorMessages();
    this.fetchEppRefDocs();
    this.fetchRefDocs('LEA');
    this.templateLeaHistoryData = [
      {
        "id": 1,
        "templatename": 'LEA Template 1',
        "uploadeddate": '2026/03/16',
        "uploadedby": "Arun",
        "status": 'Active'
      },
      {
        "id": 2,
        "templatename": 'LEA Template 2',
        "uploadeddate": '2026/03/16',
        "uploadedby": "Arun",
        "status": 'Active'
      }
    ]
    this.templateEppHistoryData = [
      {
        "id": 1,
        "templatename": 'EPP Template 1',
        "uploadeddate": '2026/03/16',
        "uploadedby": "Arun",
        "status": 'Active'
      },
      {
        "id": 2,
        "templatename": 'EPP Template 2',
        "uploadeddate": '2026/03/16',
        "uploadedby": "Arun",
        "status": 'Active'
      }
    ]
  }

  setActionColumnWidth(e) {
    const rows = e.component.getDataSource().items();

    let maxWidth = 120;

    console.log('Calculated action column width:', maxWidth);
    this.actionColumnWidth = maxWidth;
  }

  addFieldLea(field: string) {
    this.selectedFieldsLea.push(field);
    this.availableFieldsLea = this.availableFieldsLea.filter(f => f !== field);
  }

  removeFieldLea(field: string) {
    this.availableFieldsLea.push(field);
    this.selectedFieldsLea = this.selectedFieldsLea.filter(f => f !== field);
  }

  addFieldEpp(field: string) {
    this.selectedFieldsEpp.push(field);
    this.availableFieldsEpp = this.availableFieldsEpp.filter(f => f !== field);
  }

  removeFieldEpp(field: string) {
    this.availableFieldsEpp.push(field);
    this.selectedFieldsEpp = this.selectedFieldsEpp.filter(f => f !== field);
  }

  getTemplateTypes(): Promise<void> {

    return new Promise((resolve, reject) => {
      this.systemConfigurationService.getTemplateNames().subscribe({
        next: (data: any) => {
          resolve();
          console.log(data?.data.data);
          // this.templateLeaHistoryData = data?.data?.data?.data;
          const groups = data?.data?.data?.data || [];

          const allTemplates = groups.reduce((acc, group) => {
            return acc.concat(group.data);
          }, []);

          this.templateLeaHistoryData = allTemplates.filter(f => f.template_category === 'LEA');
          this.templateEppHistoryData = allTemplates.filter(f => f.template_category === 'EPP');
          this.templateLeaDropdownData = this.templateLeaHistoryData.filter(f => f.template_status?.toLowerCase() === 'active');
          this.templateEppDropdownData = this.templateEppHistoryData.filter(f => f.template_status?.toLowerCase() === 'active');
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  getLeaTemplateColumns(event: any): Promise<void> {
    return new Promise((resolve, reject) => {
      this.selectedFieldsLea = [];
      let col_value = event.value?.data_template_col_sel_id ?? null;
      let temp_value = event.value?.template_id;
      this.editbtn = false;
      //  if (col_value && temp_value) {
      this.systemConfigurationService.getTemplateDataBycolTempId(col_value, temp_value).subscribe({
        next: async (data: any) => {
          resolve();
          console.log(data.data?.data);
          this.template_name = event.value.template_name;
          if (col_value) {
            const baseList = data.data?.data?.data?.filter(f => f.base_template === 'Base');

            if (baseList && baseList.length > 0) {
              this.availableFieldsLea = data.data?.data?.data;
            }
            else {
              this.availableFieldsLea = data.data?.data?.data.filter(f => !f.is_selected);
              this.selectedFieldsLea = data.data?.data?.data.filter(f => f.is_selected);
            }

          }
          else {
            // let { available, selected } = await this.mapTemplates(data.data.data.data);
            // this.availableFieldsLea = available;
            // this.selectedFieldsLea = selected;
            this.availableFieldsLea = data.data?.data?.data;
          }
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });

      // else {
      //   this.systemConfigurationService.getTemplateColumns(temp_value).subscribe({
      //     next: (data: any) => {
      //       resolve();
      //       console.log(data.data?.data);
      //       this.availableFieldsLea = data.data?.data?.data;

      //     },
      //     error: (error) => {
      //       console.error('Error getting person data:', error);
      //       reject(error);
      //     }
      //   });
      // }


    });

  }

  async mapTemplates(data: any[]) {
    const available: any[] = [];
    const selected: any[] = [];

    const sample = data.find(t => t.type === 'Sample Templates');
    const custom = data.find(t => t.type === 'Custom Templates');

    if (!sample?.data?.length && custom?.data?.length) {
      custom.data.forEach((item: any) => {
        (!item.is_selected ? available : selected).push(item);
      });
    } else {
      sample?.data?.forEach((item: any) => available.push(item));
    }

    return { available, selected };
  }

  getEppTemplateColumns(event: any): Promise<void> {
    return new Promise((resolve, reject) => {
      let col_value = event.value?.data_template_col_sel_id;
      let temp_value = event.value?.template_id;
      this.template_name_epp = event.value?.template_name;
      this.selectedTemplateEpp = event.value;
      this.template_name_epp = event.value?.template_name;
      this.editbtn = false;
      if (col_value && temp_value) {
        this.systemConfigurationService.getTemplateDataBycolTempId(col_value, temp_value).subscribe({
          next: (data: any) => {
           console.log(data.data?.data);
          this.template_name = event.value.template_name;
          if (col_value) {
             const baseList = data.data?.data?.data?.filter(f => f.base_template === 'Base');

            if (baseList && baseList.length > 0) {
              this.availableFieldsEpp = data.data?.data?.data;
            }
            else {
              this.availableFieldsEpp = data.data?.data?.data.filter(f => !f.is_selected);
              this.selectedFieldsEpp = data.data?.data?.data.filter(f => f.is_selected);
            }

          }
          else {
            // let { available, selected } = await this.mapTemplates(data.data.data.data);
            // this.availableFieldsLea = available;
            // this.selectedFieldsLea = selected;
            this.availableFieldsEpp = data.data?.data?.data;
          }

          },
          error: (error) => {
            console.error('Error getting person data:', error);
            reject(error);
          }
        });
      }
      else {
        this.systemConfigurationService.getTemplateColumns(temp_value).subscribe({
          next: (data: any) => {
            resolve();
            const response = data.data?.data?.data || [];
            this.availableFieldsEpp = response;
            this.selectedFieldsEpp = [];
            console.log(data.data?.data);
            this.availableFieldsEpp = data.data?.data?.data;

          },
          error: (error) => {
            console.error('Error getting person data:', error);
            reject(error);
          }
        });
      }


    });
  }

  saveTemplateLeaColumns(): Promise<void> {
    this.btnclicked = true;
    const userSessionData = JSON.parse(this.sessionStorage.getItem('user'));

    if (this.template_name == '') {
      return;
    }
    else if (this.selectedTemplate?.template_id == undefined) {
      this.alertService.error('Please select existing template name');
      return;
    }
    if (this.selectedFieldsLea.length == 0) {
      return;
    }

    return new Promise((resolve, reject) => {
      let arrayIds = this.selectedFieldsLea.map(item => item.data_template_ele_id);
      let obj = {
        "data_ele_ids": arrayIds,
        "template_id": this.selectedTemplate?.template_id,
        "created_by": userSessionData.id,
        "user_id": userSessionData.id,
        "template_name": this.template_name
      };

      this.systemConfigurationService.saveTemplateColumns(obj).subscribe({
        next: (data: any) => {
          resolve();
          if (data?.data.success == false) {
            this.alertService.warn(data?.data.message);
            return;
          }
          else {
            this.alertService.success(this.lookupToast?.['T0065']);

            this.showLeacreatetemplate = false;
            this.selectedFieldsLea = [];
            this.availableFieldsLea = [];
            this.getTemplateTypes();
            this.selectedTemplate = '';
            this.template_name = '';
            this.editbtn = false;
            this.btnclicked = false;
          }
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });


  }

  saveTemplateEppColumns(): Promise<void> {
    this.btnclicked = true;
    const userSessionData = JSON.parse(this.sessionStorage.getItem('user'));

    if (this.template_name_epp == '') {
      return;
    } else if (this.selectedTemplateEpp?.template_id == undefined) {
      return;
    }
    if (this.selectedFieldsEpp.length == 0) {
      return;
    }

    return new Promise((resolve, reject) => {
      let arrayIds = this.selectedFieldsEpp.map(item => item.data_template_ele_id);
      let obj = {
        "data_ele_ids": arrayIds,
        "template_id": this.selectedTemplateEpp?.template_id,
        "created_by": userSessionData.id,
        "user_id": userSessionData.id,
        "template_name": this.template_name_epp
      };

      this.systemConfigurationService.saveTemplateColumns(obj).subscribe({
        next: (data: any) => {
          resolve();
          if (data?.data.success == false) {
            this.alertService.warn(data?.data.message);
            return;
          } else {
            this.alertService.success(this.lookupToast?.['T0065']);
            this.showEppcreatetemplate = false;
            this.selectedFieldsEpp = [];
            this.availableFieldsEpp = [];
            this.getTemplateTypes();
            this.selectedTemplateEpp = '';
            this.template_name_epp = '';
            this.editbtn = false;
            this.btnclicked = false;
          }
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  createLeaTemplate() {
    this.showLeacreatetemplate = true;
  }

  resetTemplateLeaColumns() {
    this.showLeacreatetemplate = false;
    this.selectedTemplate = '';
    this.availableFieldsLea = [];
    this.selectedFieldsLea = [];
    this.editbtn = false;
    this.template_name = '';
    this.btnclicked = false;
  }

  resetTemplateEppColumns() {
    this.showEppcreatetemplate = false;
    this.selectedTemplateEpp = null;
    this.template_name_epp = '';
    this.availableFieldsEpp = [];
    this.selectedFieldsEpp = [];
    this.editbtn = false;
    this.btnclicked = false;

  }

  createEPPTemplate() {
    this.showEppcreatetemplate = true;
  }

  deactivateLeaTemplate(): Promise<void> {
    const userSessionData = JSON.parse(this.sessionStorage.getItem('user'));
    return new Promise((resolve, reject) => {
      let obj: any = {
        "is_activate": false,
        "template_id": this.editTempId,
        "data_template_col_sel_id": this.editColSelId,
        "user_id": userSessionData?.id
      }

      if (this.editColSelId) {
        obj.template_type = 'Custom'
      }
      else {
        obj.template_type = 'Base'
      }

      this.systemConfigurationService.deactivateLeaTemplate(obj).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success(this.lookupToast?.['T0068']);
          this.showLeacreatetemplate = false;
          this.selectedFieldsLea = [];
          this.getTemplateTypes();
          this.closePopup();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });


  }

  activateLeaTemplate(): Promise<void> {
    const userSessionData = JSON.parse(this.sessionStorage.getItem('user'));
    return new Promise((resolve, reject) => {

      let obj: any = {
        "is_activate": true,
        "template_id": this.editTempId,
        "data_template_col_sel_id": this.editColSelId,
        "user_id": userSessionData?.id
      }

      if (this.editColSelId) {
        obj.template_type = 'Custom'
      }
      else {
        obj.template_type = 'Base'
      }


      this.systemConfigurationService.deactivateLeaTemplate(obj).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success(this.lookupToast?.['T0067']);
          this.showLeacreatetemplate = false;
          this.selectedFieldsLea = [];
          this.getTemplateTypes();
          this.closePopup();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });


  }

  onDownloadTemplate(value: any) {
    let url = API_ENDPOINTS.DATA_TEMPLATES.DOWNLOAD_TEMPLATES;
    let contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const item = value.data;
    this.template_name = item.template_name;
    const identity_id = 0;
    this.httpService.getDownload1(url + '/' + item.data_template_col_sel_id + '/' + item.template_id + '/' + identity_id + '/' + false + '/' + false, contentType).subscribe({
      next: (blob: Blob) => {
        const downloadLink = document.createElement('a');
        const objectUrl = URL.createObjectURL(blob);
        downloadLink.href = objectUrl;
        downloadLink.download = this.template_name;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(objectUrl);
      }
    });

  }

  onLeaEdit(data: any): Promise<void> {
    this.createLeaTemplate();
    this.editbtn = true;
    this.btnclicked = true;
    return new Promise((resolve, reject) => {
      let col_value = data?.data?.data_template_col_sel_id ?? null;
      let temp_value = data?.data?.template_id;
      this.selectedTemplate = data?.data;
      this.template_name = data?.data?.template_name;
      //  if (col_value && temp_value) {
      this.systemConfigurationService.getTemplateDataBycolTempId(col_value, temp_value).subscribe({
        next: async (data: any) => {
          resolve();
          console.log(data.data?.data);

          if (col_value) {
           const baseList = data.data?.data?.data?.filter(f => f.base_template === 'Base');

            if (baseList && baseList.length > 0) {
              this.availableFieldsLea = data.data?.data?.data;
            }
            else {
              this.availableFieldsLea = data.data?.data?.data.filter(f => !f.is_selected);
              this.selectedFieldsLea = data.data?.data?.data.filter(f => f.is_selected);
            }
          }
          else {
            // let { available, selected } = await this.mapTemplates(data.data.data.data);
            // this.availableFieldsLea = available;
            // this.selectedFieldsLea = selected;
            this.availableFieldsLea = data.data?.data?.data;
          }
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });

      // else {
      //   this.systemConfigurationService.getTemplateColumns(temp_value).subscribe({
      //     next: (data: any) => {
      //       resolve();
      //       console.log(data.data?.data);
      //       this.availableFieldsLea = data.data?.data?.data;

      //     },
      //     error: (error) => {
      //       console.error('Error getting person data:', error);
      //       reject(error);
      //     }
      //   });
      // }


    });


    // return new Promise((resolve, reject) => {
    //   let col_value = data?.data?.data_template_col_sel_id;
    //   let temp_value = data?.data?.template_id;
    //   this.template_name = data?.data?.template_name;
    //   this.selectedTemplate = data?.data;
    //   if (col_value && temp_value) {
    //     this.systemConfigurationService.getTemplateDataBycolTempId(col_value, temp_value).subscribe({
    //       next: (data: any) => {
    //         resolve();
    //         console.log(data.data?.data);
    //         this.availableFieldsLea = data.data?.data?.data;


    //       },
    //       error: (error) => {
    //         console.error('Error getting person data:', error);
    //         reject(error);
    //       }
    //     });
    //   }
    //   else {
    //     this.systemConfigurationService.getTemplateColumns(temp_value).subscribe({
    //       next: (data: any) => {
    //         resolve();
    //         console.log(data.data?.data);
    //         this.availableFieldsLea = data.data?.data?.data;

    //       },
    //       error: (error) => {
    //         console.error('Error getting person data:', error);
    //         reject(error);
    //       }
    //     });
    //   }


    // });

  }

  editTemplateLeaColumns(): Promise<void> {
    const userSessionData = JSON.parse(this.sessionStorage.getItem('user'));

    if (this.template_name == '') {
      this.alertService.error('Please enter Template name');
      return;
    }
    else if (this.selectedTemplate?.template_id == undefined) {
      this.alertService.error('Please select existing template name');
      return;
    }

    if (this.selectedFieldsLea.length == 0) {
      this.alertService.error('Please select fields');
      return;
    }


    return new Promise((resolve, reject) => {
      // if(this.selectedFieldsLea.length == 0)
      // {
      //   this.selectedFieldsLea = this.availableFieldsLea ;
      // }

      let arrayIds = this.selectedFieldsLea.map(item => item.data_template_ele_id);
      let obj = {
        "data_template_col_sel_id": this.selectedTemplate?.data_template_col_sel_id,
        "data_ele_ids": arrayIds,
        "template_id": this.selectedTemplate?.template_id,
        "created_by": userSessionData.id,
        "user_id": userSessionData.id,
        "template_name": this.template_name
      };

      this.systemConfigurationService.updateTemplateColumns(obj, this.selectedTemplate?.data_template_col_sel_id).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success(this.lookupToast?.['T0066']);
          this.showLeacreatetemplate = false;
          this.selectedFieldsLea = [];
          this.getTemplateTypes();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });


  }

  deactivateEppTemplate(value?: any): Promise<void> {
    const userSessionData = JSON.parse(this.sessionStorage.getItem('user'));
    return new Promise((resolve, reject) => {
      let obj: any = {
        "is_activate": false,
        "template_id": this.editTempId,
        "data_template_col_sel_id": this.editColSelId,
        "user_id": userSessionData?.id
      }

      if (this.editColSelId) {
        obj.template_type = 'Custom'
      }
      else {
        obj.template_type = 'Base'
      }

      this.systemConfigurationService.deactivateEppTemplate(obj).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success(this.lookupToast?.['T0068']);
          this.showEppcreatetemplate = false;
          this.selectedFieldsEpp = [];
          this.getTemplateTypes();
          this.closePopup();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });


  }

  activateEppTemplate(value?: any): Promise<void> {
    const userSessionData = JSON.parse(this.sessionStorage.getItem('user'));
    return new Promise((resolve, reject) => {
      let obj: any = {
        "is_activate": true,
        "template_id": this.editTempId,
        "data_template_col_sel_id": this.editColSelId,
        "user_id": userSessionData?.id
      }
      if (this.editColSelId) {
        obj.template_type = 'Custom'
      }
      else {
        obj.template_type = 'Base'
      }

      this.systemConfigurationService.deactivateLeaTemplate(obj).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success(this.lookupToast?.['T0067']);
          this.showEppcreatetemplate = false;
          this.selectedFieldsEpp = [];
          this.getTemplateTypes();
          this.closePopup();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });


  }

  onEppEdit(data: any): Promise<void> {

    this.createEPPTemplate();
    this.editbtn = true;
    this.btnclicked = true;
    return new Promise((resolve, reject) => {
      let col_value = data?.data?.data_template_col_sel_id;
      let temp_value = data?.data?.template_id;
      this.template_name_epp = data?.data?.template_name;
      this.selectedTemplateEpp = data?.data;
      if (col_value && temp_value) {
        this.systemConfigurationService.getTemplateDataBycolTempId(col_value, temp_value).subscribe({
          next: (data: any) => {
            resolve();
            console.log(data.data?.data);

          if (col_value) {
           const baseList = data.data?.data?.data?.filter(f => f.base_template === 'Base');

            if (baseList && baseList.length > 0) {
              this.availableFieldsEpp = data.data?.data?.data;
            }
            else {
              this.availableFieldsEpp = data.data?.data?.data.filter(f => !f.is_selected);
              this.selectedFieldsEpp = data.data?.data?.data.filter(f => f.is_selected);
            }
          }
          else {
            this.availableFieldsEpp = data.data?.data?.data;
          }


          },
          error: (error) => {
            console.error('Error getting person data:', error);
            reject(error);
          }
        });
      }
      else {
        this.systemConfigurationService.getTemplateColumns(temp_value).subscribe({
          next: (data: any) => {
            resolve();
            console.log(data.data?.data);
            this.availableFieldsEpp = data.data?.data?.data;

          },
          error: (error) => {
            console.error('Error getting person data:', error);
            reject(error);
          }
        });
      }


    });

  }

  editTemplateEppColumns(): Promise<void> {
    const userSessionData = JSON.parse(this.sessionStorage.getItem('user'));

    if (this.template_name_epp == '') {
      this.alertService.error('Please enter Template name');
      return;
    }
    else if (this.selectedTemplateEpp?.template_id == undefined) {
      this.alertService.error('Please select existing template name');
      return;
    }
    if (this.selectedFieldsEpp.length == 0) {
      this.alertService.error('Please select fields');
      return;
    }

    return new Promise((resolve, reject) => {
      let arrayIds = this.selectedFieldsEpp.map(item => item.data_template_ele_id);
      let obj = {
        "data_template_col_sel_id": this.selectedTemplateEpp?.data_template_col_sel_id,
        "data_ele_ids": arrayIds,
        "template_id": this.selectedTemplateEpp?.template_id,
        "created_by": userSessionData.id,
        "user_id": userSessionData.id,
        "template_name": this.template_name_epp
      };

      this.systemConfigurationService.updateTemplateColumns(obj, this.selectedTemplate?.data_template_col_sel_id).subscribe({
        next: (data) => {
          resolve();
          this.alertService.success(this.lookupToast?.['T0066']);
          this.showEppcreatetemplate = false;
          this.selectedFieldsEpp = [];
          this.getTemplateTypes();
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  getToastMessages(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.systemConfigurationService.getToastMessages().subscribe({
        next: (data: any) => {
          resolve();
          console.log(data?.data);
          const transformLookupArray = (arr: any[]): { [key: string]: string } => {
            const obj: { [key: string]: string } = {};
            if (Array.isArray(arr)) {
              arr.forEach(lookupItem => {
                if (lookupItem.key && lookupItem.value) {
                  obj[lookupItem.key] = lookupItem.value;
                }
              });
            }
            return obj;
          };
          this.lookupToast = transformLookupArray(data?.data);
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  getErrorMessages(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.systemConfigurationService.getErrorMessages().subscribe({
        next: (data: any) => {
          resolve();
          console.log(data?.data);
          const transformLookupArray = (arr: any[]): { [key: string]: string } => {
            const obj: { [key: string]: string } = {};
            if (Array.isArray(arr)) {
              arr.forEach(lookupItem => {
                if (lookupItem.key && lookupItem.value) {
                  obj[lookupItem.key] = lookupItem.value;
                }
              });
            }
            return obj;
          };
          this.lookupErrorMessages = transformLookupArray(data?.data);
        },
        error: (error) => {
          console.error('Error getting person data:', error);
          reject(error);
        }
      });
    });
  }

  //   onEditorPrepared(e: any) {
  //   // Apply only for filter row
  //   if (e.parentType === 'filterRow') {

  //     // 👉 For DATE columns
  //     if (e.dataField && this.isDateColumn(e.dataField)) {
  //       e.editorOptions = {
  //         filterOperations:["=","<",">"],       
  //         "allowFiltering":true,
  //         "allowSearch":{"isSearchEnable":true , "type":"date"},
  //         inputAttr:{"inputmode":"numeric","pattern":"[0-9/]*"},
  //         ...e.editorOptions,
  //         type: 'date',
  //         displayFormat: 'MM/dd/yyyy',
  //         useMaskBehavior: true,   // ✅ prevents alphabets
  //         onKeyDown: (args: any) => {
  //           const key = args.event.key;

  //           // Allow only numbers + control keys
  //           if (!/[0-9\/]/.test(key) &&
  //               !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(key)) {
  //             args.event.preventDefault();
  //           }
  //         }
  //       };
  //     }
  //   }
  // }

  onEditorPrepared(e: any): void {
    if (e.parentType === 'filterRow' && this.isDateColumn(e.dataField)) {
      e.editorElement?.addEventListener('input', (event: any) => {
        let v = event.target.value.replace(/\D/g, '').slice(0, 8);
        event.target.value = v.replace(/(\d{2})(\d{2})?(\d{0,4})?/, (_, m, d, y) =>
          [m, d, y].filter(Boolean).join('/')
        );
      });
    }
  }


   isDateColumn(field: string): boolean {
  return [...this.templateLeagridConfig, ...this.templateEppgridConfig, ...this.eppRefDocsGridConfig].some(
    col =>
      col.columnDef === field &&
      (col.dateFormat === 'date' || col.dateFormat === 'datetime')
  );
}

  activateLeaTemplatePopup(value: any, deleteModel: any) {

    this.template_name = value.data?.template_name;
    this.editColSelId = value.data?.data_template_col_sel_id;
    this.editTempId = value.data?.template_id;
    this.modalref = this.modalService.open(deleteModel, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details decision-delete-modal'
    });

  }

  deactivateLeaTemplatePopup(value: any, deleteModel1: any) {

    this.template_name = value.data?.template_name;
    this.editColSelId = value.data?.data_template_col_sel_id;
    this.editTempId = value.data?.template_id;
    this.modalref = this.modalService.open(deleteModel1, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details decision-delete-modal'
    });

  }

  closePopup() {
    this.modalService.dismissAll();
  }

  modalStatusClose() {
    this.modalService.dismissAll();
  }

  onDropdownClear() {
    this.template_name_epp = '';
    this.selectedTemplateEpp = null;
    this.template_name = '';
    this.resetTemplateLeaColumns();
    this.resetTemplateEppColumns();
  }

  onDelete(value: any, deleteModel2: any) {
    this.modalref = this.modalService.open(deleteModel2, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details decision-delete-modal'
    });
    this.deleteId = value?.data?.data_template_col_sel_id ;
  }



  deleteRow(): Promise<void> {
    return new Promise((resolve, reject) => {
     
    const userRaw = sessionStorage.getItem('user');
    const userSessionData = userRaw ? JSON.parse(userRaw) : null;
    const updatedBy = userSessionData?.user_id ?? userSessionData?.id ?? userSessionData?.userId ?? null;
       this.httpService.put(
      API_ENDPOINTS.DATA_TEMPLATES.DELETE_TEMPLATE_DATA + '/' + this.deleteId,
      { updated_by: updatedBy }
    ).subscribe({
        next: () => {        
          this.alertService.success('Deleted successfully.');
          this.getTemplateTypes();
          this.modalStatusClose();
        },
        error: () => this.alertService.error('Failed to delete reference document.')
      });

    });
  }


  activateEppTemplatePopup(value: any, deleteModelEpp: any) {
    this.template_name = value.data?.template_name;
    this.editColSelId = value.data?.data_template_col_sel_id;
    this.editTempId = value.data?.template_id;
    this.modalref = this.modalService.open(deleteModelEpp, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details decision-delete-modal'
    });

  }

getLongLabel(value: string | undefined): string {
  if (!value) return '';

  const trimmedValue = value.trim();
  const wordCount = trimmedValue.split(/\s+/).length;
  const charCount = trimmedValue.length;

  return charCount > 21 ? value : '';
}

 
  compareTemplate(a: any, b: any): boolean {
    return a && b ? a.template_id === b.template_id : a === b;
  }


  deactivateEppTemplatePopup(value: any, deleteModel1Epp: any) {
    this.template_name = value.data?.template_name;
    this.editColSelId = value.data?.data_template_col_sel_id;
    this.editTempId = value.data?.template_id;
    this.modalref = this.modalService.open(deleteModel1Epp, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details decision-delete-modal'
    });
  }

  // ─── EPP Reference Documents ───────────────────────────────────────────────

  showEppRefDocUploadModal(content: any): void {
    this.eppRefDocUploadData = { file: null, fileName: '', type: '' };
    this.eppRefDocUploadError = null;
    this.eppRefDocOneFileIsRequired = false;
    this.eppRefDocSaveEnable = false;
    this.eppRefDocShowText = false;
    this.eppRefDocShowErrorBanner = false;
    this.eppRefDocUploadModalRef = this.modalService.open(content, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  closeEppRefDocUploadPopup(): void {
    if (this.eppRefDocUploadData?.file) {
      const modalConfig: ModalConfig = {
        heading: 'Cancel File Upload',
        modalContent: 'You have started uploading a file but have not yet saved it. Are you sure you want to cancel? Any unsaved changes will be lost.',
        hasDropdown: false,
        hasTemplate: true,
        align: false,
        panelClass: 'cancelUploadModal',
        buttons: [
          { text: 'Yes, Cancel', code: 'Y' },
          { text: 'No, Continue', code: 'N', btnOutline: true }
        ]
      };
      const confirmRef = this.modalService.open(ModalComponent, {
        size: 'md',
        centered: true,
        backdrop: 'static'
      });
      confirmRef.componentInstance.modalConfig = modalConfig;
      confirmRef.componentInstance.emitData.pipe(take(1)).subscribe((result: any) => {
        confirmRef.close();
        if (result?.code === 'Y' || result?.confirmed === true) {
          this._actuallyCloseEppRefDocUploadPopup();
        }
      });
    } else {
      this._actuallyCloseEppRefDocUploadPopup();
    }
  }

  private _actuallyCloseEppRefDocUploadPopup(): void {
    this.eppRefDocUploadModalRef?.close();
    this.eppRefDocUploadModalRef = null;
    this.eppRefDocUploadData = { file: null, fileName: '', type: '' };
    this.eppRefDocUploadError = null;
    this.eppRefDocOneFileIsRequired = false;
    this.eppRefDocShowText = false;
    this.eppRefDocShowErrorBanner = false;
    this.eppRefDocSaveEnable = false;
  }

  private processEppRefDocFile(file: File): void {
    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
      'image/jpeg',
      'image/png',
      'application/pdf'
    ];
    const allowedExts = ['.xlsx', '.xls', '.jpg', '.jpeg', '.png', '.pdf'];
    const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
    const maxSize = 15 * 1024 * 1024;
    if (file.size > maxSize) {
      this.eppRefDocUploadError = this.lookupErrorMessages?.['M0128'] || 'The selected file exceeds the maximum allowed size of 15 MB.';
      this.eppRefDocUploadData.file = null;
      if (this.eppRefDocFileInputRef?.nativeElement) this.eppRefDocFileInputRef.nativeElement.value = '';
      return;
    }
    if (!allowedTypes.includes(file.type) && !allowedExts.includes(ext)) {
      this.eppRefDocUploadError = this.lookupErrorMessages?.['M0129'] || 'The selected file type is not supported.';
      this.eppRefDocUploadData.file = null;
      if (this.eppRefDocFileInputRef?.nativeElement) this.eppRefDocFileInputRef.nativeElement.value = '';
      return;
    }
    this.eppRefDocUploadData.file = file;
    this.eppRefDocUploadData.type = file.type;
    this.eppRefDocUploadData.fileName = file.name;
    this.eppRefDocOneFileIsRequired = false;
    this.eppRefDocUploadError = null;
    this.eppRefDocSaveEnable = false;
  }

  handleEppRefDocFileUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      this.eppRefDocOneFileIsRequired = true;
      this.eppRefDocUploadData.file = null;
      return;
    }
    this.processEppRefDocFile(input.files[0]);
  }

  onDropEppRefDocFile(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      this.processEppRefDocFile(event.dataTransfer.files[0]);
    }
  }

  clearEppRefDocFileInput(event: any): void {
    event.target.value = null;
  }

  onSaveEppRefDoc(): void {
    if (!this.eppRefDocUploadData.file) {
      this.eppRefDocOneFileIsRequired = true;
      return;
    }
    this.eppRefDocSaveEnable = true;
    this.eppRefDocShowText = true;
    const userRaw = sessionStorage.getItem('user');
    const userSessionData = userRaw ? JSON.parse(userRaw) : null;
    const userId = userSessionData?.user_id ?? userSessionData?.id ?? userSessionData?.userId ?? null;
    const formData = new FormData();
    formData.append('file', this.eppRefDocUploadData.file);
    formData.append('fileName', this.eppRefDocUploadData.fileName);
    formData.append('uploadedBy', userSessionData?.id);
    formData.append('createdBy', userId);
    formData.append('type', 'EPP');
    formData.append('template_category', 'EPP');
    formData.append('template_Status', 'ACTIVE');
    this.httpService.postFormData(API_ENDPOINTS.DATA_TEMPLATES.UPLOAD_REFERENCE_DOCUMENT, formData)
      .subscribe({
        next: () => {
          this.alertService.success(this.lookupToast?.['T0069'] || 'Reference document uploaded successfully.');
          setTimeout(() => {
            this._actuallyCloseEppRefDocUploadPopup();
            this.fetchEppRefDocs();
          }, 2000);
        },
        error: () => {
          this.eppRefDocErrorBannerMessage = this.lookupErrorMessages?.['M0191'] || 'An error occurred during upload.';
          this.eppRefDocShowErrorBanner = true;
          this.eppRefDocShowText = false;
          this.eppRefDocSaveEnable = false;
          this.alertService.clear();
        }
      });
  }

  exportEppRefDocs(): void {
    if (!this.eppRefDocsList.length) return;
    const visibleCols = this.eppRefDocsGridConfig.filter(c => this.eppRefDocsVisibleColumns[c.columnDef]);
    const header = visibleCols.map(c => c.header);
    const rows = this.eppRefDocsList.map(row =>
      visibleCols.map(c => {
        const v = row[c.columnDef] ?? '';
        if ((c as any).dateFormat === 'date' && v) {
          const d = new Date(v);
          if (!isNaN(d.getTime())) {
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            return `${mm}/${dd}/${d.getFullYear()}`;
          }
        }
        return typeof v === 'object' ? JSON.stringify(v) : String(v);
      })
    );
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('EPP Reference Documents');
    const headerRow = worksheet.addRow(header);
    headerRow.font = { bold: true };
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
    rows.forEach(r => worksheet.addRow(r));
    worksheet.eachRow((row: any) => {
      row.eachCell((cell: any) => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });
    });
    worksheet.columns.forEach((col: any) => { col.width = 30; });
    workbook.xlsx.writeBuffer().then((buffer: any) => {
      FileSaver.saveAs(new Blob([buffer]), 'EPP_Reference_Documents.xlsx');
    });
  }

  toggleEppRefDocColumnChooser(): void {
    this.showEppRefDocColumnChooser = !this.showEppRefDocColumnChooser;
  }

  onEppRefDocColumnToggle(colDef: string, disabled: boolean): void {
    if (disabled) return;
    this.eppRefDocsVisibleColumns[colDef] = !this.eppRefDocsVisibleColumns[colDef];
    this.eppRefDocDataGridConfig = DataGridVO.create({
      ...this.eppRefDocDataGridConfig,
      visibleColumns: { ...this.eppRefDocsVisibleColumns }
    });
  }

  onLeaRefDocColumnToggle(colDef: string, disabled: boolean): void {
    if (disabled) return;
    this.leaRefDocsVisibleColumns[colDef] = !this.leaRefDocsVisibleColumns[colDef];
    this.leaRefDocDataGridConfig = DataGridVO.create({
      ...this.leaRefDocDataGridConfig,
      visibleColumns: { ...this.leaRefDocsVisibleColumns }
    });
  }

  stripExtension(fileName: string): string {
    if (!fileName) return '';
    return fileName.replace(/\.[^.]+$/, '');
  }

  private resolveEppRefDocFileUrl(response: any): string | null {
    return (
      response?.data?.data?.p_document_blob?.file_url ||
      response?.data?.data?.p_document_blob?.fileUrl ||
      response?.data?.data?.p_document_blob?.strfileHash ||
      response?.data?.data?.p_document_blob?.file_hash ||
      response?.data?.data?.p_document_blob?.fileHash ||
      response?.data?.file_url ||
      response?.data?.fileUrl ||
      response?.data?.url ||
      response?.file_url ||
      response?.fileUrl ||
      null
    );
  }

  onDownloadEppRefDoc(data: any): void {
    const item = data.data;
    const refDocId = Number(item?.ref_document_id);
    if (!Number.isFinite(refDocId) || refDocId <= 0) {
      this.alertService.error('Document information is missing');
      return;
    }
    const fileName = String(item.file_name || `document_${refDocId}`);
    this.httpService.post(API_ENDPOINTS.DATA_TEMPLATES.DOWNLOAD_REFERENCE_DOCUMENT, { ref_document_id: refDocId })
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          const fileUrl = this.resolveEppRefDocFileUrl(response);
          if (!fileUrl) {
            this.alertService.error('Failed to download reference document.');
            return;
          }
          fetch(fileUrl)
            .then(res => res.blob())
            .then(blob => {
              FileSaver.saveAs(blob, fileName);
              this.alertService.success('Document downloaded successfully.');
            })
            .catch(() => this.alertService.error('Failed to download reference document file.'));
        },
        error: () => this.alertService.error('Failed to download reference document. Please try again.')
      });
  }

  activateEppRefDocPopup(data: any, modal: any, category: 'EPP' | 'LEA' = 'EPP'): void {
    this.selectedEppRefDocRow = data.data;
    this.selectedRefDocCategory = category;
    this.modalref = this.modalService.open(modal, { size: 'md', backdrop: 'static', windowClass: 'add-appointment-details decision-delete-modal' });
  }

  deactivateEppRefDocPopup(data: any, modal: any, category: 'EPP' | 'LEA' = 'EPP'): void {
    this.selectedEppRefDocRow = data.data;
    this.selectedRefDocCategory = category;
    this.modalref = this.modalService.open(modal, { size: 'md', backdrop: 'static', windowClass: 'add-appointment-details decision-delete-modal' });
  }

  onDeleteEppRefDocPopup(data: any, modal: any, category: 'EPP' | 'LEA' = 'EPP'): void {
    this.selectedEppRefDocRow = data.data;
    this.selectedRefDocCategory = category;
    this.modalref = this.modalService.open(modal, { size: 'md', backdrop: 'static', windowClass: 'add-appointment-details decision-delete-modal' });
  }

  activateEppRefDoc(): void {
    const userRaw = sessionStorage.getItem('user');
    const userSessionData = userRaw ? JSON.parse(userRaw) : null;
    const updatedBy = userSessionData?.user_id ?? userSessionData?.id ?? userSessionData?.userId ?? null;
    const payload = {
      ref_document_id: this.selectedEppRefDocRow?.ref_document_id,
      template_status: 'ACTIVE',
      updated_by: updatedBy
    };
    this.httpService.post(API_ENDPOINTS.DATA_TEMPLATES.ACTIVATE_REFERENCE_DOCUMENT, payload)
      .subscribe({
        next: () => {
          const category = this.selectedRefDocCategory;
          this.alertService.success(this.lookupToast?.['T0067'] || 'Reference document activated successfully.');
          this.closePopup();
          this.fetchRefDocs(category);
        },
        error: () => this.alertService.error('Failed to activate reference document.')
      });
  }

  deactivateEppRefDoc(): void {
    const userRaw = sessionStorage.getItem('user');
    const userSessionData = userRaw ? JSON.parse(userRaw) : null;
    const updatedBy = userSessionData?.user_id ?? userSessionData?.id ?? userSessionData?.userId ?? null;
    const payload = {
      ref_document_id: this.selectedEppRefDocRow?.ref_document_id,
      template_status: 'INACTIVE',
      updated_by: updatedBy
    };
    this.httpService.post(API_ENDPOINTS.DATA_TEMPLATES.ACTIVATE_REFERENCE_DOCUMENT, payload)
      .subscribe({
        next: () => {
          const category = this.selectedRefDocCategory;
          this.alertService.success(this.lookupToast?.['T0068'] || 'Reference document deactivated successfully.');
          this.closePopup();
          this.fetchRefDocs(category);
        },
        error: () => this.alertService.error('Failed to deactivate reference document.')
      });
  }

  deleteEppRefDoc(): void {
    const userRaw = sessionStorage.getItem('user');
    const userSessionData = userRaw ? JSON.parse(userRaw) : null;
    const updatedBy = userSessionData?.user_id ?? userSessionData?.id ?? userSessionData?.userId ?? null;
    const refDocId = this.selectedEppRefDocRow?.ref_document_id;
    this.httpService.put(
      API_ENDPOINTS.DATA_TEMPLATES.DELETE_REFERENCE_DOCUMENT + '/' + refDocId,
      { updated_by: updatedBy }
    ).subscribe({
        next: () => {
          const category = this.selectedRefDocCategory;
          this.alertService.success('Reference document deleted successfully.');
          this.closePopup();
          this.fetchRefDocs(category);
        },
        error: () => this.alertService.error('Failed to delete reference document.')
      });
  }

  fetchEppRefDocs(): void {
    this.fetchRefDocs('EPP');
  }

  fetchRefDocs(category: 'EPP' | 'LEA'): void {
    this.httpService.get(API_ENDPOINTS.DATA_TEMPLATES.FETCH_REFERENCE_DOCUMENTS + '/' + category)
      .subscribe({
        next: (response: any) => {
          if (category === 'EPP') {
            this.eppRefDocsList = (response?.data?.data || []).map((item: any) => {
              const rawDate = item.created_date ?? item.updated_date ?? null;
              return { ...item, created_date: rawDate ? new Date(rawDate) : null, template_status: this.formatStatusText(item.template_status) };
            });
            this.eppRefDocDataGridConfig = DataGridVO.create({
              ...this.eppRefDocDataGridConfig,
              visibleColumns: { ...this.eppRefDocsVisibleColumns },
              data: this.eppRefDocsList.map(item => ({ ...item, file_name: this.stripExtension(item.file_name) }))
            });
          } else {
            this.leaRefDocsList = (response?.data?.data || []).map((item: any) => {
              const rawDate = item.created_date ?? item.updated_date ?? null;
              return { ...item, created_date: rawDate ? new Date(rawDate) : null, template_status: this.formatStatusText(item.template_status) };
            });
            this.leaRefDocDataGridConfig = DataGridVO.create({
              ...this.leaRefDocDataGridConfig,
              visibleColumns: { ...this.leaRefDocsVisibleColumns },
              data: this.leaRefDocsList.map(item => ({ ...item, file_name: this.stripExtension(item.file_name) }))
            });
          }
        },
        error: () => {
          this.alertService.error(`Failed to load ${category} reference documents. Please try again.`);
        }
      });
  }

  // ─── LEA Reference Documents (upload + export + column chooser only — action methods reuse EPP) ───

  showLeaRefDocUploadModal(content: any): void {
    this.leaRefDocUploadData = { file: null, fileName: '', type: '' };
    this.leaRefDocUploadError = null;
    this.leaRefDocOneFileIsRequired = false;
    this.leaRefDocSaveEnable = false;
    this.leaRefDocShowText = false;
    this.leaRefDocShowErrorBanner = false;
    this.leaRefDocUploadModalRef = this.modalService.open(content, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
  }

  closeLeaRefDocUploadPopup(): void {
    if (this.leaRefDocUploadData?.file) {
      const modalConfig: ModalConfig = {
        heading: 'Cancel File Upload',
        modalContent: 'You have started uploading a file but have not yet saved it. Are you sure you want to cancel? Any unsaved changes will be lost.',
        hasDropdown: false,
        hasTemplate: true,
        align: false,
        panelClass: 'cancelUploadModal',
        buttons: [
          { text: 'Yes, Cancel', code: 'Y' },
          { text: 'No, Continue', code: 'N', btnOutline: true }
        ]
      };
      const confirmRef = this.modalService.open(ModalComponent, {
        size: 'md',
        centered: true,
        backdrop: 'static'
      });
      confirmRef.componentInstance.modalConfig = modalConfig;
      confirmRef.componentInstance.emitData.pipe(take(1)).subscribe((result: any) => {
        confirmRef.close();
        if (result?.code === 'Y' || result?.confirmed === true) {
          this._actuallyCloseLeaRefDocUploadPopup();
        }
      });
    } else {
      this._actuallyCloseLeaRefDocUploadPopup();
    }
  }

  private _actuallyCloseLeaRefDocUploadPopup(): void {
    this.leaRefDocUploadModalRef?.close();
    this.leaRefDocUploadModalRef = null;
    this.leaRefDocUploadData = { file: null, fileName: '', type: '' };
    this.leaRefDocUploadError = null;
    this.leaRefDocOneFileIsRequired = false;
    this.leaRefDocShowText = false;
    this.leaRefDocShowErrorBanner = false;
    this.leaRefDocSaveEnable = false;
  }

  private processLeaRefDocFile(file: File): void {
    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
      'image/jpeg',
      'image/png',
      'application/pdf'
    ];
    const allowedExts = ['.xlsx', '.xls', '.jpg', '.jpeg', '.png', '.pdf'];
    const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
    const maxSize = 15 * 1024 * 1024;
    if (file.size > maxSize) {
      this.leaRefDocUploadError = this.lookupErrorMessages?.['M0128'] || 'The selected file exceeds the maximum allowed size of 15 MB.';
      this.leaRefDocUploadData.file = null;
      if (this.leaRefDocFileInputRef?.nativeElement) this.leaRefDocFileInputRef.nativeElement.value = '';
      return;
    }
    if (!allowedTypes.includes(file.type) && !allowedExts.includes(ext)) {
      this.leaRefDocUploadError = this.lookupErrorMessages?.['M0129'] || 'The selected file type is not supported.';
      this.leaRefDocUploadData.file = null;
      if (this.leaRefDocFileInputRef?.nativeElement) this.leaRefDocFileInputRef.nativeElement.value = '';
      return;
    }
    this.leaRefDocUploadData.file = file;
    this.leaRefDocUploadData.type = file.type;
    this.leaRefDocUploadData.fileName = file.name;
    this.leaRefDocOneFileIsRequired = false;
    this.leaRefDocUploadError = null;
    this.leaRefDocSaveEnable = false;
  }

  handleLeaRefDocFileUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      this.leaRefDocOneFileIsRequired = true;
      this.leaRefDocUploadData.file = null;
      return;
    }
    this.processLeaRefDocFile(input.files[0]);
  }

  onDropLeaRefDocFile(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      this.processLeaRefDocFile(event.dataTransfer.files[0]);
    }
  }

  clearLeaRefDocFileInput(event: any): void {
    event.target.value = null;
  }

  onSaveLeaRefDoc(): void {
    if (!this.leaRefDocUploadData.file) {
      this.leaRefDocOneFileIsRequired = true;
      return;
    }
    this.leaRefDocSaveEnable = true;
    this.leaRefDocShowText = true;
    const userRaw = sessionStorage.getItem('user');
    const userSessionData = userRaw ? JSON.parse(userRaw) : null;
    const userId = userSessionData?.user_id ?? userSessionData?.id ?? userSessionData?.userId ?? null;
    const formData = new FormData();
    formData.append('file', this.leaRefDocUploadData.file);
    formData.append('fileName', this.leaRefDocUploadData.fileName);
    formData.append('uploadedBy', userSessionData?.id);
    formData.append('createdBy', userId);
    formData.append('type', 'LEA');
    formData.append('template_category', 'LEA');
    formData.append('template_Status', 'ACTIVE');
    this.httpService.postFormData(API_ENDPOINTS.DATA_TEMPLATES.UPLOAD_REFERENCE_DOCUMENT, formData)
      .subscribe({
        next: () => {
          this.alertService.success(this.lookupToast?.['T0069'] || 'Reference document uploaded successfully.');
          setTimeout(() => {
            this._actuallyCloseLeaRefDocUploadPopup();
            this.fetchRefDocs('LEA');
          }, 2000);
        },
        error: () => {
          this.leaRefDocErrorBannerMessage = this.lookupErrorMessages?.['M0191'] || 'An error occurred during upload.';
          this.leaRefDocShowErrorBanner = true;
          this.leaRefDocShowText = false;
          this.leaRefDocSaveEnable = false;
          this.alertService.clear();
        }
      });
  }

  exportLeaRefDocs(): void {
    if (!this.leaRefDocsList.length) return;
    const visibleCols = this.leaRefDocsGridConfig.filter(c => this.leaRefDocsVisibleColumns[c.columnDef]);
    const header = visibleCols.map(c => c.header);
    const rows = this.leaRefDocsList.map(row =>
      visibleCols.map(c => {
        const v = row[c.columnDef] ?? '';
        if ((c as any).dateFormat === 'date' && v) {
          const d = new Date(v);
          if (!isNaN(d.getTime())) {
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            return `${mm}/${dd}/${d.getFullYear()}`;
          }
        }
        return typeof v === 'object' ? JSON.stringify(v) : String(v);
      })
    );
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('LEA Reference Documents');
    const headerRow = worksheet.addRow(header);
    headerRow.font = { bold: true };
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
    rows.forEach(r => worksheet.addRow(r));
    worksheet.eachRow((row: any) => {
      row.eachCell((cell: any) => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });
    });
    worksheet.columns.forEach((col: any) => { col.width = 30; });
    workbook.xlsx.writeBuffer().then((buffer: any) => {
      FileSaver.saveAs(new Blob([buffer]), 'LEA_Reference_Documents.xlsx');
    });
  }

  toggleLeaRefDocColumnChooser(): void {
    this.showLeaRefDocColumnChooser = !this.showLeaRefDocColumnChooser;
  }

  allowOnlyValidChars(event: KeyboardEvent) {
  const char = event.key;

  // Allow only letters, numbers, _ and -
   if (!/^[a-zA-Z0-9_ '\-]$/.test(char)) {
    event.preventDefault();
  }
}

handlePaste(event: ClipboardEvent) {
  const pastedText = event.clipboardData?.getData('text') || '';

  // Block paste if invalid chars exist
  if (/[^a-zA-Z0-9_ '\-]/.test(pastedText)) {
    event.preventDefault();
  }
}

formatStatusText(value: string | undefined): string {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

}
